/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, date: NonNullable<unknown> }} Membership_Friend_Guest_UpcomingInputs */

const fr_membership_friend_guest_upcoming = /** @type {(inputs: Membership_Friend_Guest_UpcomingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, le ${i?.date}`)
};

/**

* @param {Membership_Friend_Guest_UpcomingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_upcoming = /** @type {((inputs: Membership_Friend_Guest_UpcomingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_UpcomingInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_upcoming(inputs)
});